import React, { createContext, useState } from "react";

export const SelectionContext = createContext();

const StoreContext = ({ children }) => {

    const [updateCount, setUpdateCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [messages, setMessages] = useState([]);
    const [messageUpdate, setMessageUpdate] = useState(false);
    const [notificationsAll, setNotificationsAll] = useState([]);
    const [ordersTrigger, setOrdersTrigger] = useState(false);

    return (
        <SelectionContext.Provider value={{ updateCount, setUpdateCount, notifications, setNotifications, notificationsAll, setNotificationsAll, messages, setMessages, messageUpdate, setMessageUpdate, ordersTrigger, setOrdersTrigger }}>
            {children}
        </SelectionContext.Provider>
    )

}
export default StoreContext